import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import _TemplatedMixin from 'dijit/_TemplatedMixin';
import domConstructTyped from 'dojo/dom-construct';
import List from '../List/List';
import template from './GroupedListDialog.html?raw';
import "../../GenericDialog/GenericDialog";

const domConstruct: any = domConstructTyped;

class GroupedListDialog extends compose(_WidgetBaseSP, _TemplatedMixin) {
    [key: string]: any;

    templateString: any = template;
    onChange: any = function () {};

    navDiv: any = null;
    classNameSelected: any = null;

    groupList: any = null;
    itemGroup: any = null;

    maxSelectionCount = -1;

    selectionMode = "multi";

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.groupList = new Map();
        this.itemGroup = new Map();

        this.GenericDialog.set("callback", lang.hitch(this, "_onChange"));

        this.GenericDialog.destroyOnClose = false;
        this.GenericDialog.set("TopCloseBtn", true);
        this.GenericDialog.set("cancel", true);
        this.GenericDialog.set("ok", true);

        this.navDiv = domConstruct.create("nav", {
            style: ""
        }, this.GenericDialog.subTitleNode);
    }

    clear(): void {
        this.clearItems();

        domConstruct.empty(this.GenericDialog.subTitleNode);
    }
    clearItems(): void {
        this.groupList.forEach(function (list) {
            list.clear();
            //domConstruct.destroy(list);
        }, this);
        this.groupList.clear();
        this.itemGroup.clear();

        domConstruct.empty(this.GenericDialog.textNode);

        if (this.navDiv) {
            domConstruct.destroy(this.navDiv);
        }
        this.navDiv = domConstruct.create("nav", {
            style: ""
        }, this.GenericDialog.subTitleNode);
    }

    unSelect(): void {
        this.groupList.forEach(function (list) {
            list.unSelect();
        }, this);
    }
    getSelectedValues(): any {
        return {
            groupList: this.groupList,
            itemGroup: this.itemGroup
        }
    }

    _onChange(): void {
        this.onChange(this.getSelectedValues());
    }

    _onUnselectOtherLists(selectedList: any): void {
        this.groupList.forEach(function (list) {
            if (selectedList != list) {
                list.unSelect();
            }
        }, this);
    }

    _onSetSelectionModeOtherLists(sMode: any): void {
        this.selectionMode = sMode;

        // für jede List in Grouplist selectionMode setzen
        this.groupList.forEach(function (list) {
            list.selectionMode = sMode;
        }, this);
    }

    _onChange_ListSelection(selectedIds: any): void {
        var allSelectedIds = [];

        if (this.maxSelectionCount > -1) {
            this.groupList.forEach(function (list) {

                allSelectedIds = allSelectedIds.concat(list.get("SelectedIDs"));
            }, this);

            if (allSelectedIds.length >= this.maxSelectionCount) {
                this.groupList.forEach(function (list) {
                    list.canSelect = false;
                    list.canUnSelect = true;
                }, this);
            } else {
                this.groupList.forEach(function (list) {
                    list.canSelect = true;
                    list.canUnSelect = true;
                }, this);
            }

        }
        //console.log("allSelectedIds", allSelectedIds);
    }

    add(key: any, group: any, div: any, labelTxt: any, entity: any): void {
        this.itemGroup.set(key, group);
        if (this.groupList.has(group) === false) {
            // hier habe ich noch eine Prüfungsproperty für das allgemeingeltende selectionMode eingabeaut (isEnabledMultiSelection: bool), weil das selectionMode
            // jetzt beim toggle von Options dynamiisch geändert wird für alle lists, und wir wissen müssen, ob wir den "multi" mode einschalten dürfen. Grund: xclusive selection.
            // Property isEnabledMultiSelection hat keinen setter und ist nicht weiter elevated
            var list = new List({ mandatory: false, selectionMode: this.selectionMode, isEnabledMultiSelection:true });
            list.on("unselectOtherLists", lang.hitch(this, "_onUnselectOtherLists"));
            list.on("setSelectionModeOtherLists", lang.hitch(this, "_onSetSelectionModeOtherLists"));
            list.on("change", lang.hitch(this, "_onChange_ListSelection"));

            if (this.classNameSelected != null) list.classNameSelected = this.classNameSelected;

            (list.title as any).setTitle(this.newDiv(group));

            this.groupList.set(group, list);
            this.GenericDialog.addNodeToContent(list.domNode);

            var a = domConstruct.create("a", {
                innerHTML: group,
                style: "",
                className: "w3-button"
            }, this.navDiv);
            on(a, "click", function () { list.domNode.scrollIntoView() });
        }
        this.groupList.get(group).add(key, { node: div, label: labelTxt, entity: entity });
    }

    remove(key: any): void {
        if (this.itemGroup.has(key)) {
            var group = this.itemGroup.get(key);
            //this.itemGroup.delete(key);
            lang.hitch(this.itemGroup, "delete")(key);
            if (this.groupList.has(group)) this.groupList.get(group).remove(key);
        }
    }
}
GroupedListDialog.prototype.declaredClass = 'more.Legacy.Zal.GroupedListDialog';

export default mdsWidget(GroupedListDialog);
